import { FC } from 'react';
import {
  Modal,
  useTranslation,
  useBreakpoint,
  Breakpoints,
  Button,
  ButtonStyles,
  ButtonWidth,
} from '@nextgen-web-framework/all';
import { getModalButtonAlignment } from '../../../utils/accountLifeCycleUtils';
import { ErrorConstants } from '../../../utils/Constants';
import { MessageModalProps } from './types/propTypes';
import styles from './MessageModal.module.scss';

const MessageModal: FC<MessageModalProps> = ({
  onClose,
  headline,
  primaryButton,
  secondaryButton,
  message,
  textLinkProps,
  children,
  msgArgs,
}) => {
  const t = useTranslation();
  const breakpoint = useBreakpoint();
  const isDesktop = ![Breakpoints.XS, Breakpoints.SM, Breakpoints.MD].includes(breakpoint as Breakpoints);

  const commonDoneButton = (
    <Button
      title={t('profile.AccountRenewal.doneButton')}
      onClick={onClose}
      data-testid="modal-close-button"
      buttonStyle={ButtonStyles.SOLID}
      buttonWidth={ButtonWidth.FULL_WIDTH}
    />
  );

  if (headline) {
    // Display common error if message is not found in translation
    const tranlatedMessage = message && t(message, msgArgs);
    const displayMessage =
      message && message === tranlatedMessage
        ? t(`profile.AccountRenewal.error.${ErrorConstants.GENERAL_ERROR_CODE}`)
        : tranlatedMessage;

    return (
      <Modal
        headline={t(headline)}
        primaryButtonLabel=""
        primaryButton={primaryButton ?? commonDoneButton}
        secondaryButton={secondaryButton}
        textLinkProps={textLinkProps}
        onClose={onClose}
        buttonAlignment={getModalButtonAlignment(isDesktop)}
        closeOnBackdropClick={true}
        useReactPortal
        portalContainerId="react-portal-modal"
      >
        <div className={styles['message']} data-testid="message-testid">
          {displayMessage}
          {children}
        </div>
      </Modal>
    );
  } else {
    return null;
  }
};

export default MessageModal;
